import { z } from 'zod'

import mxTranslations from '../i18n/messages/es-MX.json'

/**
 * email schema
 */
export const emailSchema = z.object({
  email: z.string().trim().email(mxTranslations?.Common?.invalid_email_address || 'Invalid email address'),
})

/**
 * Export email type
 */
export type TEmailSchema = z.infer<typeof emailSchema>
